import { create } from "zustand";
import * as authApi from "../api/auth";
export const useAuthStore = create((set) => ({
    user: null,
    bootstrapped: false,
    setUser: (u) => set({ user: u }),
    clear: () => set({ user: null }),
    // Источник истины «кто я» — GET /api/me по cookie сессии. Отказ (нет сессии,
    // сеть) — честно «не вошёл», без выдумывания пользователя.
    bootstrap: async () => {
        try {
            const user = await authApi.me();
            set({ user, bootstrapped: true });
        }
        catch {
            set({ user: null, bootstrapped: true });
        }
    },
}));
